import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Menu from './components/menu';
import InfoBox from './components/info-box';

import './B10-topic-selector.scss';

class B10TopicSelector extends Component {
	constructor(props) {
		super(props);

		const { data } = this.props;

		this.changeBackground = this.changeBackground.bind(this);
		this.showInfo = this.showInfo.bind(this);

		this.mobileBreakpoint = window.matchMedia(`(max-width: 991px)`).matches;

		if (!this.mobileBreakpoint && data?.topics?.[0]) {
			const currentTopic = data.topics[0].info;
			currentTopic.link = data.topics[0].link;
			this.state = { currentInfo: currentTopic };
		  } else {
			this.state = { currentInfo: null };
		  }

		this.backgroundImagery = React.createRef();
		this.infoBoxRef = React.createRef();
		this.currentBackground = data.topics[0]?.info?.background || data.defaultBackground;
	}

	componentDidMount() {
		this.setBackgroundImage(this.currentBackground);
	}

	setBackgroundImage = (image) => {
		const { current } = this.backgroundImagery;
		current.style.backgroundImage = `url('${image}')`;
	}

	// Amended to switch out background images on ALL links
	changeBackgroundImageOnly = (newBackground) => {
		if (newBackground !== this.currentBackground) {
			this.currentBackground = newBackground;
			this.setBackgroundImage(this.currentBackground);
		}
	}

	changeBackground(newBackground) {
		if (newBackground !== this.currentBackground) {
			this.currentBackground = newBackground;
			this.setBackgroundImage(this.currentBackground);
		}
	}

	showInfo(currentInfo) {
		if (!currentInfo) return;
		const { data } = this.props;
		const newBackground = (currentInfo?.background) ? currentInfo.background : data.defaultBackground;

		this.changeBackground(newBackground);
		this.setState({ currentInfo }, () => {
			if (currentInfo && this.mobileBreakpoint) {
			  this.infoBoxRef?.current?.scrollIntoView({ behavior: "smooth" });
			}
		  });
	}

	render() {
		const { currentInfo } = this.state;
		const { viewport, data } = this.props;
		return (
			<React.Fragment>
				<div className="B10-topic-selector__background-desktop" ref={this.backgroundImagery} />
				<div className="container">
					<div className="B10-topic-selector__wrapper">
						<Menu viewport={viewport} topics={data.topics} showInfo={this.showInfo} showBackgroundOnly={this.changeBackgroundImageOnly} />
						{currentInfo ? <InfoBox title={currentInfo.title} description={currentInfo.description} link={currentInfo.link} readMore={data.readMoreLabel} ref={this.infoBoxRef}/> : null }
					</div>
				</div>
			</React.Fragment>
		);
	}
}

B10TopicSelector.propTypes = {
	viewport: PropTypes.string,
	data: PropTypes.shape({}),
};

B10TopicSelector.defaultProps = {
	viewport: 'lg',
	data: {},
};

const mapStateToProps = (state) => {
	return {
		viewport: state.global.viewport || null,
	};
};

export default connect(mapStateToProps)(B10TopicSelector);
